import api from "@/app/api";
import { EditPage } from "@/app/components/EditPage";
import Private from "@/app/components/Private";
import { ApiContext } from "@/app/contexts/ApiContext";

export default function Page() {
  return (
    <ApiContext.Provider
      value={{
        listData: api.getMediaRates,
        getFieldOptions: api.getMediaRateFieldOptions,
        getData: api.getMediaRate,
        getFields: api.getMediaRatesFields,
        updateEntry: api.updateMediaRate,
        deleteEntry: api.deleteMediaRate,
        createEntry: api.createMediaRate,
        createFieldOption: api.createMediaRateFieldOption,
      }}
    >
      <Private>
        <EditPage />
      </Private>
    </ApiContext.Provider>
  );
}
